export default {
  methods: {
    capitalize (string) {
      return `${string[0].toUpperCase()}${string.slice(1)}`
    },
  }
}
